
import * as React from 'react';
import { Form as BForm,Button,ButtonGroup,Modal,Alert,FormGroup,ControlLabel } from 'react-bootstrap';
import *  as Types from '../../store/types';
import { getChangesToSave, getForeignProps, getMissingRequiredFields } from '../../store/selectors';
import { changeFieldValue, save, ackSaveResult } from '../../store/actions';
import EditorProps from '../../components/editorinterface';
import TextEditor from '../../components/texteditor';
import BoolEditor from '../../components/booleditor';
import LongTextEditor from '../../components/longtexteditor';
import SelectEditor from '../../components/selecteditor';
import DateEditor from '../../components/dateeditor';
import NumberEditor from '../../components/numbereditor';
import EmailEditor from '../../components/emaileditor';
import URLEditor from '../../components/urleditor';
import FileEditor from '../../components/fileeditor';
import CondEnumForeignEditor from '../../components/condenumforeigneditor';
import './index.css';
import FormPro from '../../jquery.formpro-common.js';

interface FormProps extends Types.LoadedState {
	dispatch: Function
};

type FormState = 
	{ name: 'nothingToSave', step: 'display'|'hide'} |
	{ name: 'missingRequiredFields', step: 'display'|'hide', fields: {[key:string]:boolean}} |
	{ name: 'none'};


class Form extends React.Component<FormProps,FormState> {
	constructor(props: FormProps){
		super(props);
		this.state = { name: 'none'};
		this.onChange = this.onChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onHideSaveResult = this.onHideSaveResult.bind(this);
		this.onHideNothingToSave = this.onHideNothingToSave.bind(this);
		this.onHideMissingRequiredFields = this.onHideMissingRequiredFields.bind(this);
	}

	public render() {
		const self = this;
		let fields = this.props.fields.filter(field => {

			if (field.conditionalVisibility) {
				const filterGroup = new FormPro.RecordFilterGroup(JSON.parse(field.conditionalVisibility));

				// Convert rows in format needed by RecordFilterGroup
				let rows = self.props.fields;
				rows.forEach(function(field) {
					field.values = [{value: self.props.tableRow[field.id]}];
				});

				const neededInfos = { utilisateur_code: '', carnet_code: '', carnet_owner: '' };    // Filter using user_code and carnet_code will not works

				// Return an empty array if row has been filtered
				const hideField = filterGroup.filterRows(rows, neededInfos).length == 0;
				return !hideField;
			}
			return true;
		});
		fields = fields.map(this.renderField.bind(this));
		
		return (
			<BForm>
				{fields}
				<ButtonGroup vertical block>
					<Button bsStyle="primary" onClick={this.onSave}>Save</Button>
				</ButtonGroup>
				{this.renderModal(this.state)}
			</BForm>
		);
	}

	private renderModal(formState: FormState) {

		switch(formState.name) {
			case 'nothingToSave':
				return this.renderInfoModal("No changes to save yet",this.onHideNothingToSave,
					formState.step==='display');
			case 'missingRequiredFields':
				return this.renderInfoModal("Some required fields are missing",this.onHideMissingRequiredFields,
					formState.step==='display');
			default:
				const saveResult = this.props.saveResult;
				if(!saveResult) {
					return [];
				}
				if(saveResult==="pending") {
					return this.renderSavingModal("Saving...");
				}
				if(saveResult.status==='ok') {
					return this.renderInfoModal("Changes saved",this.onHideSaveResult,!saveResult.ack);
				}
				return this.renderErrorModal(saveResult.status,this.onHideSaveResult,!saveResult.ack);
		}
	}

	private renderField(field: Types.Field) {
		const editor = this.renderEditor(field);
		if(!editor) {
			return null;
		}
		const classNames = [];
		classNames.push("fpxfFixedCode_"+field.fixed_code);
		classNames.push("fpxfType_"+field.type);
		classNames.push("fpxfId_"+field.id);
		if(field.required) {
			classNames.push("required");
		}
		if(this.state.name==="missingRequiredFields" && this.state.fields[field.id]) {
			classNames.push("missingRequired");
		}
		var isButton = field.buttonText ? true : false;
		// No label if buttonText
		if (isButton) {
			return (
				<FormGroup key={field.id} className={classNames.length ? classNames.join(" ") : undefined}>
					{editor}
				</FormGroup>
			);			
		}
		else {
			return (
				<FormGroup key={field.id} className={classNames.length ? classNames.join(" ") : undefined}>
					<ControlLabel>{field.name}</ControlLabel>
					{editor}
				</FormGroup>
			);
		}
	}

	private renderEditor(field: Types.Field) {
		const props: EditorProps = {
			field: field,
			onChange: this.onChange,
			value: this.props.tableRow[field.id]
		};
		switch(field.type) {
			case 'date':
				return <DateEditor {...props} />;
			case 'longtext':
				return <LongTextEditor {...props} />;
			case 'boolean':
				return <BoolEditor {...props}/>
			case 'int':
			case 'double':
			case 'phone':
				return <NumberEditor {...props} />;
			case 'email':
				return <EmailEditor {...props}/>
			case 'url':
			case 'autodoc':
				return <URLEditor {...props}/>
			case 'files':
				return <FileEditor {...props} 
					apiUrl={this.props.apiUrl} isNewRow={this.props.isNewRow} b_o={this.props.b_o} token={this.props.token} />

			// field belows are all handled by text editor except some special cases
			case 'shorttext':
			case 'mediumtext':
				if(field.enumColors) {
					return <SelectEditor {...props} />;
				}
			case 'enumforeign':
				if(field.enumColors) {
					return <SelectEditor {...props} />;
				}
			case 'condenumforeign':
				if(field.condEnumColors) {
					return<CondEnumForeignEditor {...props} foreignValue={getForeignProps(this.props, field)} />;
				}
			case 'color':
			case 'formula':
			case 'autonumber':
			case 'lastmodified':
			case 'colortext':
			case 'mask':
				return <TextEditor {...props} />
			default:
				return null;
		}
	}

	private renderErrorModal(error: string,onHide: any,show: boolean) {
		return (
			<Modal show={show} onHide={onHide}>
				<Modal.Header>
				  <Modal.Title>Error</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<Alert bsStyle="danger">{error}</Alert>
				</Modal.Body>

				<Modal.Footer>
				  <Button onClick={onHide}>Close</Button>
				</Modal.Footer>
			</Modal>
		);
	}

	private renderSavingModal(info: string) {
		return (
			<Modal show={true} onHide={emptyFunction} backdrop="static">
				<Modal.Header closeButton={false}>
				  <Modal.Title>Info</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<img className="loadingImg" src="loadingImg.gif"/>
					{info}
				</Modal.Body>
			</Modal>
		);
	}

	private renderInfoModal(info: string,onHide: any,show: boolean) {
		return (
			<Modal show={show} onHide={onHide}>
				<Modal.Header>
				  <Modal.Title>Info</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					{info}
				</Modal.Body>

				<Modal.Footer>
				  <Button onClick={onHide}>Close</Button>
				</Modal.Footer>
			</Modal>
		);
	}

	private onChange(fieldId: string,value: Types.FieldValue): void {
		this.props.dispatch(changeFieldValue(fieldId,value));
	}

	private onSave() {
		const missingRequired = getMissingRequiredFields(this.props);
		if(!isEmptyObject(missingRequired)) {
			this.setState({name: "missingRequiredFields", step: "display", fields: missingRequired});
			return;
		}
		const changes = getChangesToSave(this.props);
		if(isEmptyObject(changes)) {
			this.setState({name: 'nothingToSave',step: 'display'});
		}else {
			if(this.state.name==="missingRequiredFields") {
				this.setState({name: "none"});
			}
			this.props.dispatch(save(changes));
		}
	}

	private onHideSaveResult() {
		this.props.dispatch(ackSaveResult());
	}

	private onHideNothingToSave() {
		this.setState({name: 'none'});
	}

	private onHideMissingRequiredFields() {
		this.setState({name: "missingRequiredFields",step: "hide"});
	}
}

function isEmptyObject( obj: any ) {
	for (let _key in obj ) {
		return false;
	}
	return true;
}

function emptyFunction() {}


export default Form;



// WEBPACK FOOTER //
// ./src/containers/form/index.tsx